module.exports = require("./wae");